import { Injectable, Injector } from '@angular/core';
import * as VERSION from '@environments/version';
import { MODULE_VERSION } from './token.version';

@Injectable({
  providedIn: 'root',
  deps: [Injector]
})
export class VersionService {

  mustRefresh = false;
  ListOfRefreshed: Array<any> = [];
  constructor(injector: Injector) {
    const keyService = injector.get(MODULE_VERSION)
    const version = localStorage.getItem(keyService);
    if (version) {
      if (version === VERSION.VERSION.actual_version) {

      } else {
        this.mustRefresh = true;
        localStorage.setItem(keyService, VERSION.VERSION.actual_version);
      }
    } else {
      localStorage.setItem(keyService, VERSION.VERSION.actual_version);
    }
  }
  refresh(viewContainer: any) {
    if (this.mustRefresh) {
      viewContainer.refresh();
    }
  }

}
